<template>
    <div>
        <div class="widget_heading">
            <h5>
                <i class="fa fa-car" aria-hidden="true"></i>
                Más recientes
            </h5>
        </div>
        <div class="recent_addedcars">
            <ul>
                <li 
                v-for="(vehiculo, index) in recienteslocal" 
                :key="index"
                class="gray-bg">
                    <div class="recent_post_img">
                        <a :href="`/ficha_tecnica/${vehiculo._id}?type=offers`"
                            ><img 
                            :src="'https://d16vbrqyk5474c.cloudfront.net/fit-in/190x80/'+vehiculo.fotos[0]" 
                            alt="image"
                        /></a>
                    </div>
                    <div class="recent_post_title">
                        <a :href="`/ficha_tecnica/${vehiculo._id}?type=offers`">
                            {{ vehiculo.marca }}
                            {{ vehiculo.linea }}
                            {{ vehiculo.modelo }}
                        </a>
                        <p class="widget_price">$ {{ vehiculo.precio | formatNumber }}</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {mapFields} from "vuex-map-fields";

export default {
    computed: {
        ...mapFields('buscador', [
            'recienteslocal',
        ]),
    }
};
</script>

<style lang="scss" scoped></style>
